<template>
  <b-alert
    class="mt-2"
    :show="show"
    variant="warning"
  >
    <h4>{{ title }}</h4>
    <b-button
      block
      :variant="variant"
      :disabled="ignore"
      @click="$emit('ignore')"
    >
      {{ ignore ? 'Ignored' : 'Ignore' }}
    </b-button>
    <slot name="warning-message">
      <br>
    </slot>
    <b-row>
      <slot
        name="warning-list"
        :showMore="showMore"
      />
    </b-row>
    <b-row
      v-if="btnShowMore"
      align-h="end"
    >
      <b-button
        variant="outline-secondary"
        @click="showMore=!showMore"
      >
        {{ showMore ? 'Show less...' : 'Show more...' }}
      </b-button>
    </b-row>
  </b-alert>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  title: {
    type: String,
    default: '',
  },
  show: {
    type: Boolean,
    default: false,
  },
  ignore: {
    type: Boolean,
    default: false,
  },
  btnShowMore: {
    type: Boolean,
    default: false,
  },
}

@Component
export default class ValidateWarning extends Vue.extend({ props }) {
  showMore = false

  get variant () {
    return this.ignore ? 'outline-success' : 'warning'
  }
}

</script>
